// core
import { Injectable } from '@angular/core';

// services
import { RaptorQuestionService } from './raptor-question.service';
import { RaptorPredicateService } from './raptor-predicate.service';


@Injectable()
export class RaptorRepeaterService {
  repeaterValidationResults: any = {};
  areRepeatersValid?: Boolean;

  constructor(
    private raptorQuestionService: RaptorQuestionService,
    private raptorPredicateService: RaptorPredicateService
  ) { }

  public getRepeaterQuestions(formData: any) {
    let questions: Array<any> = this.raptorQuestionService.getAllQuestions(formData);
    let repeaterQuestions = questions.filter((question) => {
      return question.type === 'repeater';
    });
    return repeaterQuestions;
  }

  public repeatersValid(formData: any, form: any): void {
    let repeaterFields = this.getRepeaterQuestions(formData);
    let repeaterValidationResults: any = {};

    repeaterFields.forEach((repeaterField: any) => {
      let repeaterFieldValues = repeaterField.data;

      // don't check if multiple repeaters are valid as they
      // can disable the submit button before showing the validation message
      // and make the form unsubmittable
      if (repeaterField.layout !== 'multiple') {
        repeaterValidationResults[repeaterField.key] = [];
        if (repeaterFieldValues && repeaterFieldValues.length) {
          repeaterFieldValues.forEach((repeaterItem: any) => {
            let itemValidation: any = {};
            // this is the individual repeater item
            for (let question in repeaterItem) {
              // get the predicates for the question
              let formField = repeaterField.elements.find((el: any) => {
                return el.key === question;
              });
              let mockFormValues: any = {};

              for (let itemKey in repeaterItem) {
                mockFormValues[itemKey] = repeaterItem[itemKey];
              };

              if (formField && formField.validations && formField.validations.length) {
                let validationArray: any = [];

                formField.validations.forEach((validation: any) => {
                  validationArray.push({
                    valid: this.raptorPredicateService.validator(validation.predicate, form.value, mockFormValues), 
                    message: validation.message 
                  });
                });
                itemValidation[question] = validationArray;
              } else {
                itemValidation[question] = { valid: true };
              }
            }
            repeaterValidationResults[repeaterField.key].push(itemValidation);
          });
        }
      }
    });
    
    this.repeaterValidationResults = repeaterValidationResults;
    this.areRepeatersValid = this.stepRepeatersValid();
  }

  public stepRepeatersValid(): boolean {
    let isValid = true;

    for (let repeater in this.repeaterValidationResults) {
      isValid = this.isRepeaterValid(repeater);
    }
    return isValid;
  }

  public isRepeaterValid(repeater: any): boolean {
    let isValid = true;
    let repeaterResults = this.repeaterValidationResults[repeater];

    if (repeaterResults.length && Array.isArray(repeaterResults)) {
      repeaterResults.forEach((repeaterItem: any) => {
        if (!this.isRowValid(repeaterItem)) {
          isValid = false;
        }
      });
    }

    return isValid;
  }

  public getFirstInvalidRow(repeater: any) {
    let repeaterResults = this.repeaterValidationResults[repeater];
    let invalidRow: any = null;

    if (repeaterResults.length && Array.isArray(repeaterResults)) {
      repeaterResults.forEach((repeaterItem: any, index: number) => {
        if (!this.isRowValid(repeaterItem) && !invalidRow) {
          invalidRow = {index: index, errors: []};
        }
      });
    }
    return invalidRow;
  }

  public isRowValid(repeaterItem: any): boolean {
    let isValid = true;

    for (let question in repeaterItem) {
      let questionValue = repeaterItem[question];

      // multiple predicates on this repeater item
      if (questionValue.length && Array.isArray(questionValue)) {
        questionValue.forEach((item: any) => {
          if (item.valid === false) {
            isValid = false;    
          }
        });
      } else if (questionValue.valid === false) {
        isValid = false;
      }
    }
    return isValid;
  }
  
}
